// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createStore } from "effector";
import { KeywordInfoResponseDTO } from "../../api/backend-openapi";
import {
  addKeyword,
  deleteKeyword,
  setKeywords,
  updateKeyword
} from "./KeywordEvents";

export const KeywordStore = createStore<KeywordInfoResponseDTO[]>([])
  .on<KeywordInfoResponseDTO[]>(
    setKeywords,
    (state: KeywordInfoResponseDTO[], payload: KeywordInfoResponseDTO[]) =>
      payload
  )
  .on<string>(
    deleteKeyword,
    (state: KeywordInfoResponseDTO[], payload: string) =>
      state.filter(news => news.id !== payload)
  )
  .on<KeywordInfoResponseDTO>(
    addKeyword,
    (state: KeywordInfoResponseDTO[], payload: KeywordInfoResponseDTO) => [
      ...state,
      payload
    ]
  )
  .on<KeywordInfoResponseDTO>(
    updateKeyword,
    (state: KeywordInfoResponseDTO[], payload: KeywordInfoResponseDTO) => [
      ...state.filter(news => news.id !== payload.id),
      payload
    ]
  );
